var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77083 1.26H9.91667C9.83646 1.26 9.77083 1.197 9.77083 1.12V1.26H4.22917V1.12C4.22917 1.197 4.16354 1.26 4.08333 1.26H4.22917V2.52H2.91667V1.12C2.91667 0.50225 3.43984 0 4.08333 0H9.91667C10.5602 0 11.0833 0.50225 11.0833 1.12V2.52H9.77083V1.26ZM0.583334 2.52H13.4167C13.7393 2.52 14 2.77025 14 3.08V3.64C14 3.717 13.9344 3.78 13.8542 3.78H12.7531L12.3029 12.9325C12.2737 13.5292 11.7596 14 11.138 14H2.86198C2.23854 14 1.7263 13.531 1.69713 12.9325L1.24688 3.78H0.145834C0.0656252 3.78 0 3.717 0 3.64V3.08C0 2.77025 0.260677 2.52 0.583334 2.52ZM3.00234 12.74H10.9977L11.4388 3.78H2.5612L3.00234 12.74Z",
    fill: "#2E314E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.bb395298fe12163181a94b677a12a43c.svg";
export { ForwardRef as ReactComponent };